export default __webpack_public_path__ + "static/appleMain-1bd099d9d4f6595cd5ec8c3236036035.svg";